var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-card",
    { attrs: { title: "" } },
    [
      _c("mds-list-group", [
        _c(
          "div",
          { staticClass: "schedules-tab__content" },
          [
            _c("mds-icon", { attrs: { name: "calendar", size: "small" } }),
            _vm._v(" "),
            _c("mds-list-group-item", {
              staticClass: "schedules-tab__title",
              attrs: {
                text: _vm.translate(
                  "flyover.feeds.schedules.card.schedule.label"
                ),
                microcopy: _vm.schedule.name,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "schedules-tab__content" },
          [
            _c("mds-icon", { attrs: { name: "refresh", size: "small" } }),
            _vm._v(" "),
            _c("mds-list-group-item", {
              staticClass: "schedules-tab__title",
              attrs: {
                text: _vm.translate(
                  "flyover.feeds.schedules.card.recurrence.label"
                ),
                microcopy: _vm.schedule.frequency.repeatType,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "schedules-tab__content" },
          [
            _c("mds-icon", { attrs: { name: "clock", size: "small" } }),
            _vm._v(" "),
            _c("mds-list-group-item", {
              staticClass: "schedules-tab__title",
              attrs: {
                text: _vm.translate(
                  "flyover.feeds.schedules.card.nextRun.label"
                ),
                microcopy: _vm.formattedNextRun,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }